// This file is consumed from two different roots and must resolve under both.
// Each MFE's Dockerfile does `COPY --from=mfe-shell-src src/exported/. ./src/`,
// so here it is `exported/pages/...` and there it is `src/pages/...` — which is
// why marlin-v2-mfe's AlertSoundSelect can import it as a plain sibling. The
// asset paths below must therefore stay RELATIVE: `@/` means `mfe_shell/src` in
// the shell build and the MFE's own `src` in the MFE build, so an `@/shared/...`
// import here resolves to a different directory in each and breaks one of them.
// Moving this file, or the sounds, out of `exported/` drops them from the MFE
// overlay and fails the mfe_shell_combined build with an unresolved
// "./soundAssets".
import bellMp3 from "../../../../shared/assets/sounds/bell.mp3";
import chimeMp3 from "../../../../shared/assets/sounds/chime.mp3";
import quickChimeWav from "../../../../shared/assets/sounds/quick-chime.wav";
import bonusWav from "../../../../shared/assets/sounds/bonus.wav";
import bubbleWav from "../../../../shared/assets/sounds/bubble.wav";
import confirmationWav from "../../../../shared/assets/sounds/confirmation.wav";
import digitalToneWav from "../../../../shared/assets/sounds/digital-tone.wav";
import dryPopWav from "../../../../shared/assets/sounds/dry-pop.wav";
import sweepWav from "../../../../shared/assets/sounds/sweep.wav";
import happyBellWav from "../../../../shared/assets/sounds/happy-bell.wav";
import longPopWav from "../../../../shared/assets/sounds/long-pop.wav";
import softRemoveWav from "../../../../shared/assets/sounds/soft-remove.wav";
import mysteryWav from "../../../../shared/assets/sounds/mystery.wav";

export const SOUND_ASSETS = {
  BELL: bellMp3,
  CHIME: chimeMp3,
  QUICK_CHIME: quickChimeWav,
  BONUS: bonusWav,
  BUBBLE: bubbleWav,
  CONFIRMATION: confirmationWav,
  DIGITAL_TONE: digitalToneWav,
  DRY_POP: dryPopWav,
  SWEEP: sweepWav,
  HAPPY_BELL: happyBellWav,
  LONG_POP: longPopWav,
  SOFT_REMOVE: softRemoveWav,
  MYSTERY: mysteryWav,
} as const;

export type SoundType = keyof typeof SOUND_ASSETS;
export type AlertSound = SoundType | "MUTE";
